import type { StateCreator } from 'zustand';

export const onboardingSteps = 3;
export type OnboardingSteps = 1 | 2 | 3;

export interface OnboardingState {
  currentStep: number;
  totalSteps: number;
  nextStep: () => void;
  prevStep: () => void;
  setStep: (step: number) => void;
  onboardingAnswers: Record<string, string>;
  setOnboardingAnswers: (obj: { questionId: string; stepAns: string }) => void;
}

export const createOnboardingState: StateCreator<OnboardingState> = (set) => ({
  currentStep: 0,
  totalSteps: onboardingSteps,
  onboardingAnswers: {},
  nextStep: () =>
    set((state) => {
      if (state.currentStep === onboardingSteps - 1) return { ...state };
      return { currentStep: state.currentStep + 1 };
    }),
  prevStep: () =>
    set((state) => {
      if (!state.currentStep) return { ...state };
      return { currentStep: state.currentStep - 1 };
    }),
  setStep: (step: number) => set(() => ({ currentStep: step })),
  setOnboardingAnswers: ({ questionId, stepAns }: { questionId: string; stepAns: string }) =>
    set((state) => {
      return {
        onboardingAnswers: {
          ...state.onboardingAnswers,
          [questionId]: stepAns
        }
      };
    })
});
